import type { DemoMetadata } from "@/registry/types";

export const metadata: DemoMetadata = {
  id: "graphql",
  name: "graphql.name",
  description: "graphql.description",
  longDescription: "graphql.longDescription",
  category: "shared.categories.architecture",
  tags: "graphql.tags",
  featured: false,
  status: "coming-soon",
  architecture: "graphql.architecture",
  technologies: "graphql.technologies",
  concepts: "graphql.concepts",
  i18nNamespace: "graphql",
};
